<dialog-header [dialogRef]="dialogRef" headerKey="ORDERS.KOL" />
<div mat-dialog-content>
  <button mat-flat-button color="primary" type="button" (click)="download()">{{ 'DOWNLOAD_KOL' | translate }}</button>
  <ng-container *ngIf="canSendCard">
    <mat-divider></mat-divider>
    <div class="send-section">
      <mat-form-field>
        <mat-label>{{ 'FILE' | translate }}</mat-label>
        <input class="fake-input-file" matInput [placeholder]="'FILE' | translate" readonly [value]="fileName" (click)="openFilePicker(inputFile)">
        <button type="button" mat-icon-button matSuffix (click)="openFilePicker(inputFile)">
          <mat-icon>attach_file</mat-icon>
        </button>
      </mat-form-field>
      <input type="file" hidden #inputFile accept="application/pdf" (change)="selectFile($event, inputFile)">
      <button mat-flat-button color="primary" type="button" [disabled]="!fileName" (click)="send()">{{ 'SEND_KOL' | translate }}</button>
    </div>
  </ng-container>
  <mat-divider></mat-divider>

  <mat-accordion>
    <mat-expansion-panel (opened)="loadHistory()">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'ORDERS.CARD.HISTORY' | translate }}</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="history">
        <div class="history-item" *ngFor="let item of history">
          <span class="date">{{ item.date }}</span>
          <span class="author">{{ item.author }}</span>
          <span class="action">{{ 'ORDERS.CARD.ACTION.' + item.action | translate }}</span>
        </div>
        <div class="no-history" *ngIf="!historyLoading && !history.length">{{ 'ORDERS.CARD.EMPTY_HISTORY' | translate }}</div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <buttons-wrapper>
    <ng-container *ngIf="canDeleteCard">
      <button mat-flat-button color="primary" type="button" (click)="delete()">{{ 'DELETE_KOL' | translate }}</button>
    </ng-container>
    <div class="flex-grow"></div>
    <button mat-flat-button type="button" mat-dialog-close>{{ 'CLOSE' | translate }}</button>
  </buttons-wrapper>
</div>
